var _path, _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6424_40403",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 7,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81624 6.52821C7.06012 6.78587 7.06111 7.21314 6.82001 7.46838L1.04256 13.7992C0.807311 14.0666 0.417884 14.0666 0.175688 13.8012C-0.0591041 13.5445 -0.0581491 13.1154 0.177699 12.848L5.04251 7.5272L5.49468 6.99998L5.04612 6.47667L0.175689 1.13961C-0.0585454 0.883538 -0.0585454 0.455482 0.175582 0.198925C0.41761 -0.0662882 0.805865 -0.0665971 1.04164 0.199732L6.81624 6.52821Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6424_40403)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.96167,
    y: 100,
    width: 100,
    height: 13,
    transform: "rotate(-90 -2.96167 100)",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6424_40403",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 0,
    width: 14,
    height: 100
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2.96167,
    y: 100,
    width: 100,
    height: 13,
    transform: "rotate(-90 -2.96167 100)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6424_40403)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.85324b1e.svg";
export { ForwardRef as ReactComponent };